<script setup>

const props = defineProps({
    stats: {
        type: Object,
        required: true
    },
})

</script>

<template>
    <div>
        <container-with-tooltip
            v-if="stats.labels.includes('above_average_opening_rate')"
            alignment="left"
            vertical-alignment="top"
            class="flex justify-center items-center cursor-default"
        >
            <span class="relative text-xxs">
                <i
                    v-if="stats.labels.includes('above_average_opening_rate')"
                    class="fa-solid fa-arrow-trend-up text-myflowGreen text-lg"
                ></i>
            </span>

            <template #tooltip>
                <div class="text-xs bg-white rounded-md p-1 whitespace-nowrap">
                    {{ _mft('communication:openRate.aboveAverage') }}
                </div>
            </template>
        </container-with-tooltip>

        <container-with-tooltip
            v-if="stats.labels.includes('below_average_opening_rate')"
            alignment="left"
            vertical-alignment="top"
            class="flex justify-center items-center cursor-default"
        >
            <span class="relative text-xxs">
                <i
                    v-if="stats.labels.includes('below_average_opening_rate')"
                    class="fa-solid fa-arrow-trend-down text-gray-400 text-lg"
                ></i>
            </span>

            <template #tooltip>
                <div class="text-xs bg-white rounded-md p-1 whitespace-nowrap">
                    {{ _mft('communication:openRate.belowAverage') }}
                </div>
            </template>
        </container-with-tooltip>

        <container-with-tooltip
            v-if="stats.total_deliveries"
            alignment="left"
            vertical-alignment="top"
            class="flex justify-center items-center cursor-default"
        >
            <span class="relative text-xxs">
                <i class="fa-solid fa-envelope-circle-check text-gray-400 mr-0.5 text-xs"></i>
                {{ stats.total_deliveries }}
            </span>

            <template #tooltip>
                <div class="text-xs bg-white rounded-md p-1 whitespace-nowrap">
                    {{ _mft('communication:automation.sentTo.prefix') }} {{ stats.total_deliveries }}
                    {{ _mft('communication:automation.sentTo.suffix') }}
                </div>
            </template>
        </container-with-tooltip>

        <container-with-tooltip
            v-if="stats.opening_rate"
            alignment="left"
            vertical-alignment="top"
            class="flex justify-center items-center cursor-default"
        >
            <span class="relative text-xxs">
                <i class="fa-solid fa-envelope-open text-gray-400 mr-0.5 text-xs"></i>
                {{ stats.opening_rate }}%
            </span>

            <template #tooltip>
                <div class="text-xs bg-white rounded-md p-1 whitespace-nowrap">
                    {{ _mft('communication:automation.openedBy.prefix') }} {{ stats.opening_rate }}
                    {{ _mft('communication:automation.openedBy.suffix') }}
                </div>
            </template>
        </container-with-tooltip>

        <container-with-tooltip
            v-if="stats.failed_deliveries > 0"
            alignment="left"
            vertical-alignment="top"
            class="flex justify-center items-center"
        >
            <span class="relative text-xxs">
                <i
                    class="fa-solid fa-triangle-exclamation mr-0.5 text-xs"
                    :class="stats.labels.includes('high_failure_rate') ? 'text-myflowRed' : 'text-myflowYellow'"
                ></i>
                {{ stats.failed_deliveries }}
            </span>

            <template #tooltip>
                <div class="text-xs bg-white rounded-md p-1 whitespace-nowrap">
                    {{ _mft('communication:automation.issues', {count: stats.failed_deliveries}) }}
                </div>
            </template>
        </container-with-tooltip>
    </div>
</template>

<style scoped>

</style>
